import './virtualFocus.css';
export var virtualFocus = {neutral:'_9mvxlq0-3-5-0',primary:'_9mvxlq1-3-5-0'};